import { atom } from "jotai";
import { atomFamily } from "jotai/utils";

import { UnUploadedImage } from "components/PhotoUpload/types";

import { createDerivedSessionAtom } from "./utils/createDerivedSessionAtom";
import { createPersistedAtom } from "./utils/createPersistedAtom";

const sessionDamagePhotosAtom = atomFamily((sessionId: string) =>
  createPersistedAtom<UnUploadedImage[]>(`damagePhotos-${sessionId}`, [])
);

export const damagePhotosAtom = createDerivedSessionAtom<UnUploadedImage[]>(sessionDamagePhotosAtom);

export const isMinimumPhotoUploadedAtom = atom((get) => get(damagePhotosAtom).length >= 3);
